import React from 'react';
import colors from '../../../scss/colors';

function ValidationErrorLabel(props) {
  const { classes, message, color = colors.ERROR_RED, fontSize = '12px' } = props;

  return <span className={classes} style={{ color, fontSize }}>{message}</span>;
}

export default ValidationErrorLabel;
